import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'app-top-customers',
	templateUrl: './top-customers.component.html',
	styleUrls: ['./top-customers.component.scss']
})
export class TopCustomersComponent implements OnInit {

	constructor() { }
	@Input() analyticsData = [
		{
			name: 'Grant Welch',
			ordersTotal: 106,
			revenue: '3,464 SAR',
		},
		{
			name: 'John Doe',
			ordersTotal: 152,
			revenue: '5,320 SAR',
		},
		{
			name: 'Jane Smith1',
			ordersTotal: 89,
			revenue: '2,780 SAR',
		},
	];

	ngOnInit(): void {
	}

}
